<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-page-container>
        <video
          autoplay
          loop
          muted
          :ratio="16/9"
          class="custom-video"
        >
          <source type="video/mp4" :src="require('@/assets/video/video-login.mp4')" />
        </video>
        <RecordarPassword
        :isDebugMode="$store.getters['PF/isDebugMode']"
        class="absolute-center"
        style="width: 422px; height: 466px"
         ></RecordarPassword>
      </q-page-container>
    </q-layout>
  </div>
</template>
<script>
import { QLayout, QPageContainer } from 'quasar';
import RecordarPassword from '../components/RecordarPassword.vue';

export default {
  components: {
    RecordarPassword,
    QLayout,
    QPageContainer
  }
};
</script>

<style lang="scss" scoped>
.custom-video {
  position:absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
  z-index: -999;
  top: 0;
  left: 0;
}
</style>
